export enum EventProgressType {
	Unknown = "unkown",
	NoMember = "nomember",
	Participating = "participating",
	Waiting = "waiting",
	Invited = "invited",
}
